import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Utils } from 'src/app/core/resources/utils';
import { Global } from 'src/app/core/resources/global';
import { NgxSpinnerService } from 'ngx-spinner';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { RolesService } from '../roles.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Permission, PermissionJLRB } from 'src/app/core/resources/permission';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Role, RoleModel } from 'src/app/core/interfaces/role';
import { ModulesService } from '../../module/modules.service';
import { ModuleRole } from 'src/app/core/interfaces/moduleRole';
import { FunctionalitiesService } from '../../Functionalities/functionalities.service';
import { FunctionalitiesModuleRole } from 'src/app/core/interfaces/functionalitiesModuleRole';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Fmt } from 'src/app/core/messages/fmt';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { Companies } from 'src/app/core/resources/companies';
import { NotificationCatalog } from 'src/app/core/interfaces/notification-catalog';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { Subscription } from 'rxjs';
import { Company } from 'src/app/core/interfaces/company';
import { finalize } from 'rxjs/operators';
import { Reports } from 'src/app/core/interfaces/report';
import { RoleComany } from 'src/app/core/interfaces/roleCompany';
import { StorageService } from 'src/app/core/services/storage.service';
@Component({
  selector: 'app-form-role',
  templateUrl: './form-role.component.html',
  styleUrls: ['./form-role.component.scss'],
  providers: [AuthService, RoleModel, ModulesService, FunctionalitiesService]
})
export class FormRoleComponent implements OnInit {

  title: string;
  companySelected: FormControl = new FormControl('', Validators.required);
  companySub: Subscription;
  validate = '';
  mode: string;
  roleData: Role;
  form: FormGroup = new FormGroup({});
  listModules: ModuleRole[];
  optionsCompany = {
    title: 'Compañía'
  };
  isJLRBCompany: boolean = this.authService && this.authService.getUserSession().clientCompanyId === '9007387182';
  companyReportLabels: { [key: string]: string } = {};
  permission = this.isJLRBCompany ? PermissionJLRB : Permission;
  notificationsCatalog: Array<NotificationCatalog> = [];
  formNotifications = new FormGroup({});
  notificationFormLoaded = false;

  constructor(
    private authService: AuthService,
    private rolesService: RolesService,
    public utils: Utils,
    private global: Global,
    private spinner: NgxSpinnerService,
    private snackBarService: SnackBarService,
    private router: Router,
    private route: ActivatedRoute,
    public formBuilder: FormBuilder,
    public roleModel: RoleModel,
    private modulesService: ModulesService,
    private functionalitiesService: FunctionalitiesService,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private permissionRole: PermissionRole
  ) {

  }

  async ngOnInit() {
    if (this.route.routeConfig === null || this.route.routeConfig.path === 'create') {
      this.mode = 'create';
      this.title = 'Crear rol';
    } else {
      this.mode = 'detail';
    }
    await this.initializeAll();
    this.setSubscriptionCompany();
  }

  private async initializeAll() {
    this.spinner.show();
    //Get list modules
    const { success: successModules, listModules } = await this.getListModules();
    if (!successModules) {
      this.snackBarService.openSnackBar('Ocurrió un error al obtener los módulos', undefined, 'error');
      this.spinner.hide();
      this.goToList();
      return;
    }
    this.listModules = listModules;
    //Get list functionalities
    const { success: successFunctionalities, listFunctionalities } = await this.getListFunctionalities();
    if (!successFunctionalities) {
      this.snackBarService.openSnackBar('Ocurrió un error al obtener los permisos', undefined, 'error');
      this.spinner.hide();
      this.goToList();
      return;
    }
    const functGroypByModule = this.utils.arrayGroupBy(listFunctionalities, 'moduleId');
    this.listModules = this.listModules.map((module) => {
      module.functionalities = functGroypByModule[module.id];
      return module;
    });
    this.removeIdsModules();
    //Set detail role if exists
    const params = this.route.snapshot.params;
    if (!this.utils.objIsEmpty(params) && this.utils.isDefined(params.id)) {
      const role = await this.getRole(params['id']);
      if (!role) {
        this.snackBarService.openSnackBar('Ocurrió un error al obtener el rol', undefined, 'error');
        this.goToList();
        return;
      }
      this.createFormFromRole(role);
      await this.loadNotifications();
    }
    this.spinner.hide();
  }

  private async getListModules(): Promise<{ success: boolean, listModules: ModuleRole[] }> {
    let listModules: ModuleRole[] = [];
    try {
      const response = await this.modulesService.getAllModules().toPromise();
      listModules = response && response.length ? response : [];
    } catch (error) { }
    return { success: listModules.length > 0, listModules };
  }

  private async getListFunctionalities(): Promise<{ success: boolean, listFunctionalities: FunctionalitiesModuleRole[] }> {
    let listFunctionalities: FunctionalitiesModuleRole[] = [];
    try {
      const response = await this.functionalitiesService.getFunctionalitiesByIdModule().toPromise();
      listFunctionalities = response && response.length ? response : [];
    } catch (error) { }
    return { success: listFunctionalities.length > 0, listFunctionalities };
  }

  private removeIdsModules() {
    this.listModules = this.listModules.map((module) => {
      delete module.id;
      module.functionalities = module.functionalities.map((functionality) => {
        delete functionality.id;
        delete functionality.moduleId;
        functionality.visible = false;
        return functionality;
      });
      return module;
    });
  }

  private async getRole(id: string): Promise<Role> {
    if (this.rolesService.roleSelected) return this.rolesService.roleSelected;
    if (id) return this.getDetailRole(id);
    return null;
  }

  private async getDetailRole(id: string): Promise<Role> {
    let role: Role = null;
    try {
      const response = await this.rolesService.getRol(id).toPromise();
      role = response ? response : null;
    } catch (error) { }
    return role;
  }

  private createFormFromRole(role: Role) {
    const model = this.normalize(role);
    this.roleData = model;
    this.title = this.roleData.name;
    this.form = this.utils.createFormGroupFromObject(model);
    this.form.get('name').setValidators(Validators.required);
    this.form.patchValue(model);
    if (!this.permissionRole.hasPermission(this.permission.administration.module, this.permission.administration.updateRoles))
      this.form.disable();
  }

  private createFormFromCompany(companyId: string) {
    let model = this.roleModel.model;
    model['modules'] = this.listModules;
    model['nit'] = companyId;
    model = this.normalize(model);
    this.form = this.utils.createFormGroupFromObject(model);
    this.form.get('name').setValidators(Validators.required);
    this.form.get('nit').setValue(companyId);
    if (!this.permissionRole.hasPermission(this.permission.administration.module, this.permission.administration.createRoles))
      this.form.disable();
  }

  /** Indica si el usuario en sesión tiene correo de dominio @innovbo.com. */
  private isInnovboUser(): boolean {
    const email = this.authService && this.authService.getUserSession() && this.authService.getUserSession().email;
    return !!email && email.toLowerCase().endsWith('@innovbo.com');
  }

  private normalize(role: Role) {
    const _modules = {};
    // Creación del template con todos los posibles permisos. Accesible por nombre de permiso.
    for (const m in this.permission) {
      const module = this.permission[m];
      // El módulo de rastreo satelital es solo-innovbo: no se muestra/asigna a usuarios de otro dominio.
      if (module['module'] === 'satelliteTracking' && !this.isInnovboUser()) {
        continue;
      }
      const template = {
        name: module['module'],
        functionalities: {}
      }
      for (const permissionName in module) {
        if (permissionName !== 'module') {
          const permission = {
            name: module[permissionName],
            visible: false
          };
          template.functionalities[module[permissionName]] = (permission);
        }
      }
      if (template.name === 'reports')
        template.functionalities = this.addReportsFunctionalities(role && role.nit ? role.nit : null);
      _modules[template.name] = template;
    }
    // Asignación de permisos actuales a modules.
    for (const m of role.modules) {
      for (const p of m.functionalities) {
        if (!p) continue;
        p.name;
        p.visible;
        if (_modules[m.name] && _modules[m.name].functionalities && _modules[m.name].functionalities[p.name]) _modules[m.name].functionalities[p.name] = p;
      }
    }
    const normalizedRole: Role = role;

    normalizedRole.modules = [];
    for (const m in _modules) {
      const module = {
        name: m,
        functionalities: []
      }

      const functionalities = _modules[m].functionalities;
      for (const f in functionalities) {
        module.functionalities.push(functionalities[f]);
      }

      normalizedRole.modules.push(module);
    }
    return normalizedRole;
  }

  private getCompanyReports(companyId: string): Reports[] {
    if (!companyId || !this.authService || !this.authService.getCompanies() || !this.authService.getCompanies().length) return [];
    const company = this.authService.getCompanies().find(company => company.companyId === companyId);
    if (!company) return [];
    if (!company.configuration || !company.configuration.reports || !company.configuration.reports.length) return [];
    return company.configuration.reports;
  }

  private addReportsFunctionalities(companyId: string): { [key: string]: FunctionalitiesModuleRole } {
    const reports = this.getCompanyReports(companyId);
    if (!reports.length) return {};
    const functionalities: { [key: string]: FunctionalitiesModuleRole } = {};
    for (const report of reports) {
      const reportFunctionality = {
        name: report.type,
        label: report.title,
        visible: false
      }
      functionalities[report.type] = reportFunctionality;
      this.companyReportLabels[report.type] = report.title;
    }
    return functionalities;
  }

  private setSubscriptionCompany() {
    this.companySub = this.companySelected.valueChanges.subscribe((company: Company) => {
      if (company && company.companyId) this.createFormFromCompany(company.companyId);
      else this.form = new FormGroup({});
    })
  }

  private async loadNotifications() {
    if (!this.canEditNotifications) return;
    let notificationsCatalog: Array<NotificationCatalog> = [];
    try {
      const response = await this.rolesService.getNotifications().toPromise();
      notificationsCatalog = response && response.length ? response : [];
    } catch (error) { }
    if (!notificationsCatalog.length) return;
    this.notificationsCatalog = notificationsCatalog;
    this.notificationsCatalog.forEach(
      (notificationCatalog: NotificationCatalog) => {
        const active = !!this.roleData &&
          this.roleData.notificationTypes &&
          this.roleData.notificationTypes.includes(notificationCatalog.id);
        this.formNotifications.addControl(
          notificationCatalog.id,
          new FormControl(active)
        );
      }
    );
    this.notificationFormLoaded = true;
  }

  onSubmitRole() {
    this.validate = 'touched';
    if (!this.form.value.nit)
      return this.snackBarService.openSnackBar(Fmt.string(FormMessages.MISSING_FIELD, 'compañía asociada'), undefined, 'alert');
    if (!this.form.value.name)
      return this.snackBarService.openSnackBar(Fmt.string(FormMessages.MISSING_FIELD, 'nombre del rol'), undefined, 'alert');
    if (!this.form.value.modules.some(module => module.functionalities.some(func => func.visible)))
      return this.snackBarService.openSnackBar(Fmt.string(FormMessages.UNSELECTED_FIELD, 'ninguna funcionalidad en este rol'), undefined, 'alert');
    if (this.mode === 'detail' && !this.form.value.id)
      return this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');

    const body = { ...this.form.value };
    body.modules = body.modules.map(module => {
      module.functionalities = module.functionalities.map(functionality => {
        return { name: functionality.name, visible: functionality.visible };
      });
      return module;
    });

    if (this.mode === 'create') this.createRole(body);
    else this.updateRole(body);
  }

  private createRole(body: RoleComany) {
    this.spinner.show();
    this.rolesService.createRole(body).subscribe(
      (success: any) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar('Rol creado correctamente');
        this.goToList();
      },
      (error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar('Ocurrió un error al crear el rol', 'error');
      }
    );
  }

  private updateRole(body: RoleComany) {
    this.spinner.show();
    this.rolesService.updateRole(body).subscribe(
      (success: any) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar('Rol actualizado correctamente');
        this.rolesService.roleSelected = null;
        this.goToList();
      },
      (error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(error.message || 'Ocurrió un error al crear el rol', 'error');
      }
    );
  }

  goToList() {
    this.router.navigate(['administration/roles/list']);
  }

  get formControlModules(): FormArray {
    return this.form.get('modules') as FormArray;
  }

  getFormControlFunctionalities(indexModule: number): FormArray {
    return (this.form.get('modules') as FormArray).at(indexModule).get('functionalities') as FormArray;
  }

  get canEditPermissions() {
    if (this.mode == 'detail')
      return this.permissionRole.hasPermission(this.permission.administration.module, this.permission.administration.updateRoles);
    return this.permissionRole.hasPermission(this.permission.administration.module, this.permission.administration.createRoles);
  }

  get canEditNotifications() {
    return this.permissionRole.hasPermission(
      this.permission.administration.module,
      this.permission.administration.changeRolNotifications
    );
  }

  canEditModule(module: string): boolean {
    return Companies.modulesAccess(module, this.clientCompanyId, StorageService.checkStorage().getItem('_companyId'));
  }
  canEditSomePermission(index: number): boolean {
    if (!this.getFormControlFunctionalities(index) || !this.getFormControlFunctionalities(index).controls) return false
    return this.getFormControlFunctionalities(index).controls.some(permission => this.canEditPermission(permission.value.name));
  }

  canEditPermission(permission: string): boolean {
    return Companies.permissionAccess(permission, this.clientCompanyId, StorageService.checkStorage().getItem('_companyId')) && this.authService.hasSettingAccess(permission);
  }
  getReportLabel(permission: string): string {
    return this.companyReportLabels[permission] ? this.companyReportLabels[permission] : null;
  }

  get clientCompanyId(): string {
    if (this.roleData && this.roleData.nit)
      return this.roleData.nit;
    if (this.companySelected.value && this.companySelected.value.companyId)
      return this.companySelected.value.companyId;
    return this.authService && this.authService.getUserSession().clientCompanyId;
  }

  countActivePermissions(index: number): number {
    if (!this.getFormControlFunctionalities(index) || !this.getFormControlFunctionalities(index).controls) return 0;
    return this.getFormControlFunctionalities(index).controls.filter(permission =>
      this.canEditPermission(permission.value.name) &&
      permission && permission.get('visible') && permission.get('visible').value
    ).length;
  }

  countVisiblePermissions(index: number): number {
    if (!this.getFormControlFunctionalities(index) || !this.getFormControlFunctionalities(index).controls) return 0;
    return this.getFormControlFunctionalities(index).controls.filter(permission =>
      this.canEditPermission(permission.value.name)
    ).length;
  }

  everyPermissionIsActive(index: number): boolean {
    if (!this.getFormControlFunctionalities(index) || !this.getFormControlFunctionalities(index).controls) return false
    return this.getFormControlFunctionalities(index).controls.every(permission => {
      return !this.canEditPermission(permission.value.name) ||
        (permission && permission.get('visible') && permission.get('visible').value)
    });
  }

  onSelectAll($event: MatCheckboxChange, index: number) {
    if ($event && this.utils.isDefined($event.checked)) {
      this.getFormControlFunctionalities(index).controls.forEach(permission => {
        if (this.canEditPermission(permission.value.name))
          permission.get('visible').setValue(!!$event.checked);
      });
    }
  }

  copy(text: string) {
    navigator.clipboard
      .writeText(text)
      .then(
        () => this.snackBarService.openSnackBar('¡ID copiado al portapapeles!')
      );
  }

  async updateNotification() {
    let isSomeNotificationToChange = false;
    const notifications = { ...this.formNotifications.value };
    let roleCurrentNotifications = [];
    if (this.roleData && this.roleData.notificationTypes && this.roleData.notificationTypes.length) roleCurrentNotifications = [...this.roleData.notificationTypes];
    this.spinner.show();
    for (const id in notifications) {
      const notification: boolean = notifications[id];
      let serviceToUse: string = null;
      if (notification && (!Array.isArray(roleCurrentNotifications) || !roleCurrentNotifications.includes(id)))
        serviceToUse = 'addNotificationToRole';
      else if (Array.isArray(roleCurrentNotifications) && roleCurrentNotifications.includes(id) && !notification)
        serviceToUse = 'removeNotificationToRole';
      if (serviceToUse) {
        isSomeNotificationToChange = true;
        let updatedRole: Role = null;
        try {
          updatedRole = await this.rolesService[serviceToUse](id, this.roleData.id).toPromise();
        } catch (error) { }
        if (!updatedRole) {
          this.snackBarService.openSnackBar("Ocurrió un error al actualizar las notificaciones", undefined, 'error');
          this.formNotifications.get(id).setValue(serviceToUse === 'addNotificationToRole' ? true : false);
          this.spinner.hide();
          return;
        }
      }
    }
    this.spinner.hide();
    if (!isSomeNotificationToChange) this.snackBarService.openSnackBar('No hay cambios para guardar', undefined, 'info');
    else this.snackBarService.openSnackBar('Notificaciones actualizadas correctamente');
    this.rolesService.roleSelected = null;
    this.goToList();
  }

  isEnabledFintech() {
    const emails = ['arodriguez@teclogi.com', 'alrodriguez@teclogi.com', 'lcamargo@teclogi.com', 'fsilva@teclogi.com', 'jaider.benavides@innovbo.com', 'andres.rodriguez@innovbo.com', 'alejandra.rodriguez@innovbo.com', 'laura.camargo@innovbo.com', 'felipe.silva@innovbo.com', 'jcuberos@teclogi.com', 'johan.cuberos@innovbo.com'];
    try {
      if (this.authService && emails.includes(this.authService.getUserSession().email)) {
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  }

  get isEnabledSeals() {
    return this.authService && this.authService.getCompanySaaS() &&
      Companies.companiesNIT.TECLOGI === this.authService.getCompanySaaS().companyId;
  }

  public ruleExternalApps(module: ModuleRole) {
    return this.isEnabledFintech() || this.isEnabledSeals || (module.name !== 'fintech' && module.name !== 'seals');
  }

}

